export default "__VITE_ASSET__IV28wW3h__"